import React from "react";
import { EntryImageType } from "../../GratefulDB";
import "./EntryImage.scss";

const EntryImage: React.FC<{
  image: EntryImageType;
}> = (props): JSX.Element => {
  return (
    <div
      className="EntryImage"
      style={{ backgroundImage: `url(${props.image.url})` }}
    />
  );
};

export default EntryImage;
